import SettingsBasePage from "@/settings/SettingsBasePage";
import TeacherStudentDirectoryTable from "@/teacher/TeacherStudentDirectoryTable";

const SETTINGS_BASE_PAGE_PROPS = {
  title: "Student directory",
  breadcrumbsLinks: {
    href: "/account/students/",
    contents: "Student Directory",
  },
  showHeaderSeparator: true,
};

const StudentsSettingsPage = () => {
  return (
    <SettingsBasePage {...SETTINGS_BASE_PAGE_PROPS}>
      <TeacherStudentDirectoryTable />
    </SettingsBasePage>
  );
};

export default StudentsSettingsPage;
